// @ commons
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const {
    INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_REQUEST,
    INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_SUCCESS,
    INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_FAILURE
} = require('../../insuranceConstants/actionTypes');

const modifyInsuranceRequest = (isModifying, hasBeenModified) => ({
    type: INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_REQUEST,
    data: {isModifying, hasBeenModified}
})

const modifyInsuranceSuccess = () => ({
    type: INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_SUCCESS,
})

const modifyInsuranceFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_MODIFY_INSURANCE_FAILURE,
    data: { error }
})
const modifyInsurance = (isModifying = true, hasBeenModified = false) => dispatch => {
    dispatch(modifyInsuranceRequest(isModifying, hasBeenModified));
    if(isModifying) {
        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestRelatedModify'
        })
            .then(() => {
                dispatch(modifyInsuranceSuccess());
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(modifyInsuranceFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
}

module.exports = {
    modifyInsurance
};
